import React, { Component } from 'react';
import { BrowserRouter as Router,Route,Link } from 'react-router-dom';

class ExamBtn extends Component {
    render() {
        return (
            <>
                <button type="button" className="btn exam-all-btn" onClick={this.props.onOpen}>
                    <span className="icon-wrap">
                        <svg className="icon paper-icon" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 16 16">
                            <path className="fill" d="M1386.287,121.341a.9.9,0,0,0-.192-.287l-5.332-5.332a.919.919,0,0,0-.287-.192.909.909,0,0,0-.343-.069H1374.8a.889.889,0,0,0-.889.889v14.222a.889.889,0,0,0,.889.889h10.667a.889.889,0,0,0,.889-.889v-8.889A.888.888,0,0,0,1386.287,121.341Zm-5.265-2.845,2.3,2.3h-2.3Zm-5.333,11.187V117.239h3.556v4.444a.888.888,0,0,0,.888.889h4.445v7.111Z" transform="translate(-1367.725 -111.484)" fill="#999"/>
                        </svg>
                    </span>
                    <b>전체문제</b>
                    <span>&nbsp;(90)</span>
                </button>
                <button type="button" className="btn exam-check-btn hide-btn" onClick={this.props.onOpen}>
                    <span className="icon-wrap">
                        <svg className="icon check-icon" xmlns="http://www.w3.org/2000/svg"  viewBox="5 5 14 14">
                            <path className="fill" d="M85.286,162.286a.854.854,0,0,1-.606-.251l-3.429-3.429a.857.857,0,0,1,1.212-1.212l2.823,2.823,6.251-6.252a.857.857,0,0,1,1.212,1.212l-6.857,6.858A.857.857,0,0,1,85.286,162.286Z" transform="translate(-75 -146)" fill="#999"/>
                        </svg>
                    </span>
                    <b>체크문제</b>
                    <span>&nbsp;(90)</span>
                </button>
                <button type="button" className="btn exam-none-btn hide-btn" onClick={this.props.onOpen}>
                    <span className="icon-wrap">
                        <svg className="icon none-icon" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 16 16">
                            <g transform="translate(-236.812 -146.022)">
                                <path className="fill" d="M253.885,160.06a.889.889,0,0,0-1.257,0l-1.149,1.149-1.149-1.149a.889.889,0,1,0-1.257,1.257l1.149,1.149-1.149,1.149a.889.889,0,1,0,1.257,1.257l1.149-1.149,1.149,1.149a.889.889,0,0,0,1.257-1.257l-1.149-1.149,1.149-1.149A.887.887,0,0,0,253.885,160.06Z" fill="#999"/>
                                <path className="fill" d="M254.774,154.727l-4.444-4.445a.888.888,0,0,0-.629-.26h-6.222a.889.889,0,0,0-.889.889v14.222a.889.889,0,0,0,.889.889h3.556a.889.889,0,0,0,0-1.778h-2.667V151.8h4.357v3.556a.889.889,0,0,0,.889.889h3.643v1.778a.889.889,0,0,0,1.778,0v-2.667A.885.885,0,0,0,254.774,154.727Zm-4.271-1.758,1.5,1.5h-1.5Z" fill="#999"/>
                            </g>
                        </svg>
                    </span>
                    <b>안푼 문제</b>
                    <span>&nbsp;(90)</span>
                </button>
                {/* <Link to="/examResult"> */}
                    <button type="button" className="btn result-btn">
                        <span className="icon-wrap">
                            <svg className="icon result-icon" xmlns="http://www.w3.org/2000/svg" viewBox="3 3 18 18">
                                <g transform="translate(-269.397 -111.484)">
                                    <path className="fill" d="M288.508,120.818H286.73a.889.889,0,1,0,0,1.778h.889v7.111H275.175V122.6h.889a.889.889,0,0,0,0-1.778h-1.778a.889.889,0,0,0-.889.889V130.6a.889.889,0,0,0,.889.888h14.222a.889.889,0,0,0,.889-.888v-8.889A.889.889,0,0,0,288.508,120.818Z" fill="#999"/>
                                    <path className="fill" d="M279.359,119.668l1.149-1.149v8.965a.889.889,0,0,0,1.778,0v-8.965l1.149,1.149a.888.888,0,0,0,1.257-1.256l-2.667-2.667a.889.889,0,0,0-1.257,0l-2.666,2.667a.888.888,0,1,0,1.257,1.256Z" fill="#999"/>
                                </g>
                            </svg>
                        </span>
                        <b>답안제출</b>
                        <span>&nbsp;(90)</span>
                    </button>
                {/* </Link> */}
            </>
        );
    }
}

export default ExamBtn;